export default __webpack_public_path__ + "static/media/III-2018.8e654a73.pdf";